import { usePasteText } from "./data";
import { PasteCodeUI } from "./ui";

const PasteCode = () => {
  const { handlePasteText } = usePasteText();
  return <PasteCodeUI handlePaste={handlePasteText} />;
};

export { PasteCode };
